<script lang="ts">
    import {
        type ParticipantInput,
        ParticipantProfileLinkQueryDocument,
    } from '$gql/graphql';
    import { useFragment } from '$gql';
    import { query } from '$lib/apollo/SvelteApollo';
    import ParticipantProfileLink from '$components/ParticipantProfileLink/ParticipantProfileLink.svelte';
    import { ParticipantProfileLinkFragmentDoc } from '$gql/graphql.js';

    export let id: ParticipantInput;
    export let withCard = false;
    export let target: '_blank' | undefined = '_blank';
    export let rel: string | undefined = 'noreferrer';
    export let label: string | null = null;

    let className = '';
    export { className as class };

    const { result } = query(ParticipantProfileLinkQueryDocument, {
        variables: {
            participant: id,
        },
    });

    $: participant =
        useFragment(ParticipantProfileLinkFragmentDoc, $result.data?.participant) ?? null;
</script>

{#if participant == null}
    <slot {participant}>
        <span class={className}>
            {label}
        </span>
    </slot>
{:else}
    <slot {participant}>
        <ParticipantProfileLink
            {participant}
            {withCard}
            {target}
            {rel}
            {label}
            class={className}
        />
    </slot>
{/if}
